export default interface CasiUserAgreement {
    agreementText: CasiUserAgreementContent[];
}

export type CasiUserAgreementContent =
    | { type: CasiUserAgreementContentType.Text; content: string }
    | {
          type: CasiUserAgreementContentType.Link;
          content: string;
          href: string;
      };

export enum CasiUserAgreementContentType {
    Text = "Text",
    Link = "Link",
}
